export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'boltGallery': { id: 'boltGallery', page: 'gallery', getter: () => import(/* webpackChunkName: 'gallery' */ 'components/bolt/gallery/gallery') },
	'boltSynopsis': { id: 'boltSynopsis', page: 'synopsis', getter: () => import(/* webpackChunkName: 'synopsis' */ 'components/bolt/synopsis/synopsis') },
	'partners': { id: 'partners', page: 'imageTiles', getter: () => import(/* webpackChunkName: 'imageTiles' */ 'components/bolt/imageTiles/imageTiles') },
	'videoGallery': { id: 'videoGallery', page: 'gallery', getter: () => import(/* webpackChunkName: 'gallery' */ 'components/bolt/gallery/gallery') }
};
export const sections = [
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore', parent: 'boltHome' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
